import {addFilter} from "@wordpress/hooks";

/**
 * Block Filter to hide unwanted blocks from the Gutenberg inserter
 * 
 * This JavaScript solution allows you to hide specific blocks from appearing
 * in the block inserter. They can still be found via search if needed.
 * 
 * NOTE: For reordering categories to appear at the top, use the PHP solution
 * in template-scripts.php (block_categories_all filter). The PHP approach
 * is the recommended way to prioritize your custom block categories.
 */

// Configuration: Define blocks to hide from default inserter
// These blocks won't appear in the inserter but can still be found via search
const HIDDEN_BLOCKS = [
    // Add block names here if you want to hide specific blocks
    // Examples:
    // 'core/verse',
    // 'core/preformatted',
    // 'core/archives',
    // 'core/calendar',
];

/**
 * Filter to modify block settings and hide unwanted blocks
 * This runs when blocks are registered and removes them from the inserter
 */
addFilter(
    'blocks.registerBlockType',
    'template-scripts/filter-blocks',
    (settings, name) => {
        // Hide blocks if they're in the hidden list
        if (HIDDEN_BLOCKS.includes(name)) {
            return {
                ...settings,
                supports: {
                    ...settings.supports,
                    inserter: false,
                },
            };
        }
        
        return settings;
    }
);

/**
 * SUMMARY:
 * 
 * 1. PHP Solution (template-scripts.php):
 *    - Reorders block categories so your custom categories appear first
 *    - This is the BEST way to prioritize categories in the inserter
 *    - Already implemented in your codebase
 * 
 * 2. JavaScript Solution (this file):
 *    - Hides specific blocks from the inserter
 *    - Useful for cleaning up the inserter by removing rarely-used blocks
 *    - Blocks can still be found via search
 * 
 * To prioritize your custom blocks:
 * - The PHP solution already handles category reordering
 * - Your blocks in 'template-scripts' and 'template-widgets' categories
 *   will now appear at the top of the category list in the inserter
 */
